import { generateSetChild, generateUpdateArrayChild, generateAddArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'

export default {
	namespaced: true,
	state: {
		rules: [],
		edited: false,
	},
	actions: {
		async additionalProductsAdjust({dispatch, state, getters, rootGetters}, {products}) {
			let accumulatorGroup = "additionaladjust"
			let productsToAdd = []

			let adjustmentsAsync = products.reduce((prev, product) => {
				let basketItem = getters.additionalItems
					.find(item => item.code == product.code)

				if (!basketItem && product.quantity > 0) {
					//push for later use
					productsToAdd.push({
						productCode: product.code,
						quantity: product.quantity
					})
					return prev
				} else if(basketItem && basketItem.quantity != product.quantity) {
					prev.push(
						dispatch(
							'cart/updateItem',
							{
								identifier: basketItem.id,
								quantity: product.quantity,
								accumulatorGroup
							},
							{root: true})
					)
				}
				return prev
			},[])

			// append all products to add
			if (productsToAdd.length > 0) {
				adjustmentsAsync.push(
					dispatch(
						'cart/addItems',
						{
							items: productsToAdd,
							accumulatorGroup
						},
						{root: true}
					)
				)
			}

			let results = await Promise.all(adjustmentsAsync)

			return results
		},

		async additionalProductsReset({state, dispatch, getters, rootState}) {

			let products = getters.additionalItemRules
				.reduce((prev, rule) => {
					return prev.concat(
						rule.products.map((product, i) => {
							let quantity = rule.grantedAmount
							//apply free quantity only ot the first product
							if (i > 0) {
								quantity = 0
							}
							return {
								code: product.code,
								quantity: quantity,
							}
						})
					)
				}, [])

				const [, result] = await Promise.all([
					dispatch('additionalProductsAdjust', {products}),
					service.resetAdditinoalProducts({ token: rootState.cart.basketToken, channel: rootState.cart.basketChannel, accumulatorGroup: 'additionaladjust'}), // this should be last, otherwise the whole thing fails sometimes
				]);

				return result;
		},
		additionalProductsEdited({commit}, edited) {
			commit('setEdited', {item: edited});
		},
	},
	getters: {
		items(state, getters, rootState, rootGetters) {
			return rootGetters["cart/items"]
				.filter(p => p.isAdditional != true)
		},
		additionalItems(state, getters, rootState, rootGetters) {
			return rootGetters["cart/items"]
				.filter(item => item.isAdditional == true)
				//HACK: this works only if we join 2 items
				.reduce((prev, item, i, items) => {
					let sameProduct = items.slice(i + 1).find(other => item.code == other.code)
					if (sameProduct != null && sameProduct != item && item.hide != true) {
						let newItem = {
							...item,
							total: item.total + sameProduct.total,
							originalTotal: item.originalTotal + sameProduct.originalTotal,
							quantity: item.quantity + sameProduct.quantity,
							origIds: [item.id, sameProduct.id]
						}
						sameProduct.hide = true
						prev.push(newItem)
					} else if (item.hide) {
						//do nothing
					} else {
						prev.push(item)
					}
					return prev
				}, [])
		},
		additionalItemsPrice(state, getters) {
			return getters.additionalItems
				.reduce((p, c) => p + c.originalTotal, 0)
		},

		additionalItemRules(state, getters, rootState, rootGetters) {
			let rules = []
			let additionalProducts = rootState.cart.serverData
				&& rootState.cart.serverData.availableAdditionalProducts
			if (additionalProducts) {
				rules = additionalProducts
					.map(rule => {
						return {
							...rule,
							products: rule.products.map(p => rootState.cart.productMap[p])
						}
					})
			}
			return rules
		},

		additionalItemsAvailable(state, getters, rootState, rootGetters) {
			const itemsInCart = !!rootState.cart.items.filter(item => item.isAdditional).length;

			return rootState.cart.serverData
				&& rootState.cart.serverData.availableAdditionalProducts
				&& !!rootState.cart.serverData.availableAdditionalProducts.length
				&& itemsInCart;
		},
		additionalItemsEdited(state) {
			return state.edited;
		}
	},
	mutations: {
		setEdited: generateSetChild("edited"),
	}
}
